import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (event) =>
    present(
      repository
        .getVideoConferenceCallLinks(event)
        .then((links) => ({ event, links }))
        .catch(() => Promise.reject(event)),
    );
}

export type { Interactor };

export { createInteractor };
